<scf-user-profiles-single [isUpdate]="false" (selectedProfile)="deleteProfile($event)"></scf-user-profiles-single>
